import { render, staticRenderFns } from "./num-type-select.vue?vue&type=template&id=14954cba"
import script from "./num-type-select.vue?vue&type=script&lang=ts"
export * from "./num-type-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports